import { api, unwrap } from './client';

export async function listVendors() {
  const res = await api.get('/finance/vendors');
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listActiveVendors() {
  const res = await api.get('/finance/vendors/active');
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function getVendor(id) {
  const res = await api.get(`/finance/vendors/${id}`);
  return unwrap(res);
}

export async function createVendor(payload) {
  const res = await api.post('/finance/vendors', payload);
  return unwrap(res);
}

export async function updateVendor(id, payload) {
  const res = await api.put(`/finance/vendors/${id}`, payload);
  return unwrap(res);
}

export async function deleteVendor(id) {
  const res = await api.delete(`/finance/vendors/${id}`);
  return unwrap(res);
}

export async function toggleVendor(id) {
  const res = await api.put(`/finance/vendors/${id}/toggle`);
  return unwrap(res);
}
